export const carouselInicio = [
    
   
    {
        "imagen" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/CA_445.png",
        "url": "/BPCD"
    },
    {
        "imagen" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/CA_335.png",
        "url": "/Programas/DI2026"
    },
    {
        "imagen" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/CA_336.png",
        "url": "/Convocatorias/Conv001"
    },
    {
        "imagen" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/CA_337.png",
        "url": "/DGSP"
    },
    {
        "imagen" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/CA_341.png",
        "url": "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/vid/CA_350.mp4"
    },
    {
        "imagen" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/CA_342.png",
        "url": ""
    },
    {
        "imagen" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/CA_339.png",
        "url": ""
    },
    {
        "imagen" : "https://transparenciadocs.hidalgo.gob.mx/ENTIDADES/SEBISO/web/img/CA_340.png",
        "url": ""
    },





]